import { render, staticRenderFns } from "./standalone.vue?vue&type=template&id=1656ed44"
import script from "./standalone.vue?vue&type=script&lang=js"
export * from "./standalone.vue?vue&type=script&lang=js"
import style0 from "../digital-shelf/shortcut.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./standalone.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports